  <template>
    <div>
      <video ref="videoPlayer" class="video-js vjs-big-play-centered vjs-default-skin"></video>
    </div>
  </template>

<script>
import videojs from "video.js";
import "video.js/dist/video-js.css";

export default {
  name: "VideoComponent",
  props: ["options"],
  mounted() {
    // Inizializza il lettore video al momento del montaggio del componente
    this.initializeVideoPlayer();
  },
  methods: {
    initializeVideoPlayer() {
      // Opzioni per il lettore video

      console.log(this.options);

      // Inizializza il lettore video
      this.player = videojs(this.$refs.videoPlayer, this.options);
    },
  },
  beforeUnmount() {
    // Distruggi il lettore video prima di distruggere il componente
    if (this.player)
    {
      this.player.dispose();
    }
  },
};
</script>

<style>
/* Puoi aggiungere stili CSS personalizzati qui */
</style>